$(function(){

  //smooth scroll on anchor click
  function resolveOfferSectionTarget() {
    return document.getElementById('subs-product2') || document.getElementById('subs-product');
  }

  function resolveScrollTarget(href) {
    if (href === '#' || href === '') {
      return resolveOfferSectionTarget();
    }
    if (!href) return null;
    var id = href.slice(1);
    if (!id) return resolveOfferSectionTarget();
    var target = document.getElementById(id);
    if (target) return target;
    // Theme editor typo: #subs-products (plural)
    if (id === 'subs-products') {
      target = resolveOfferSectionTarget();
      if (target) return target;
    }
    // Buy blocks on some templates use id="subs-product2" while header/legacy CTAs still use #subs-product
    if (id === 'subs-product') {
      target = document.getElementById('subs-product2');
      if (target) return target;
    }
    if (id === 'subs-product2') {
      target = document.getElementById('subs-product');
      if (target) return target;
    }
    return null;
  }

  function bindAnchorScroll(anchor) {
      anchor.addEventListener('click', function (e) {
          const href = this.getAttribute('href');
          const target = resolveScrollTarget(href);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({
              behavior: 'smooth'
          });
      });
  }

  document.querySelectorAll('a[href^="#"]').forEach(bindAnchorScroll);
  /* Theme editor sometimes leaves empty href or "#"; still scroll to offer block */
  document.querySelectorAll('.header--button a[href="#"], .header--button a[href=""], .image-with-text_Btn a[href=""], .image-with-text_Btn a[href="#"], .autoship-section a[href=""], .autoship-section a[href="#"]').forEach(bindAnchorScroll);

})


function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;
  console.log(firstElement);
  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}



$(function(){
  toolkit.setup_sr();
  toolkit.scrollWatch();

  toolkit.setup_viz_watcher(0.3);




  $("#x-anim-1 path").each(function(i,e){
    toolkit.path_prepare(e)
  })

  $("#x-anim-2 path").each(function(i,e){
    toolkit.path_prepare(e)
  })
  
})

$(function() {
  var lastScrollTop = 0;

  const element = document.getElementsByTagName("header");

  // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
  $(window).on("scroll", function(){ // or window.addEventListener("scroll"....
     var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
     if (st > lastScrollTop){ //scrolling down

       if (st > 100){
         $(element).removeClass("active");
         $(element).removeClass("bg-black");
         $(element).addClass("inactive");
       }


     } else { //scrolling up
       $(element).removeClass("inactive");
       $(element).addClass("active");
       $(element).addClass("bg-black");

       if (st == 0){
         $(element).removeClass("bg-black");
       }
     }
     lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  });

});




/*
  This is a toolkit that we use across several sites. Its fairly generic and includes things that
  usually come up in site dev
*/
const toolkit = {

  //for animating svgs
  path_prepare: function(e) {
    var lineLength = e.getTotalLength();
    $(e).css("stroke-dasharray", lineLength);
    $(e).css("stroke-dashoffset", lineLength);
  },


  //set a cookie
  set_cookie: function(name,value,days){
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  },

  //get a cookie
  get_cookie: function(name){
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  },

  //nuke a cookie
  erase_cookie: function(name){
    document.cookie = name+'=; Max-Age=-99999999;';
  },


  //get a query var
  get_query_variable: function(name){
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  //set a query var
  set_query_variable: function(key, value){
    var uri = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      var new_url = uri.replace(re, '$1' + key + "=" + value + '$2');
      history.replaceState ({path:new_url}, null, new_url);
    }
    else {
      var new_url = uri + separator + key + "=" + value;
      history.replaceState ({path:new_url}, null, new_url);
    }
  },

  //nuke a query var
  remove_query_variable: function(sParam){
    var url = window.location.href.split('?')[0]+'?';
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] != sParam) {
            url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
        }
    }

    var new_url = url.substring(0,url.length-1);
    history.replaceState ({path:new_url}, null, new_url);
  },

  scrollWatch: function(){
    var lastScrollTop = 0;

    const element = document.getElementsByTagName("header");

    // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
    $(window).on("scroll", function(){ // or window.addEventListener("scroll"....
       var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
       if (st > lastScrollTop){
          $("header").removeClass("active");
       } else {
         $("header").addClass("active");
         $("header").addClass("bg-black");
       }
       lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);


  },


  setup_sr: function(){

  	$("*[reveal]").each(function(index,element){
      var delay = $(element).attr("data-delay") || 200;
      var direction = $(element).attr("data-direction") || "bottom"
      var duration = $(element).attr("data-duration") || 0
      var distance = $(element).attr("data-distance") || "0px"
      var reset = $(element).attr("data-reset") || false
      var scale = $(element).attr("data-scale") || 1

      var options = {
        distance: distance,
        origin: direction,
        duration: duration,
        delay: delay,
        viewFactor: 0.3,
        opacity:0,
        reset:reset,
        scale: scale,
        easing: 'ease-out'
      }
      ScrollReveal().reveal(element, options)
    })
  },
  


  setup_viz_watcher: function(threshold) {

    if (!threshold) threshold = 0.3

    window.obz_callbacks = {}

    window.obz = new IntersectionObserver(function(els) {

      for (var el of els) {
        if (el.isIntersecting === true) {
          $(el.target).addClass("visible")
          
          if (window.obz_callbacks[el.target.id])
            window.obz_callbacks[el.target.id](el.target)
        }
        else {
          $(el.target).removeClass("visible")
        }
      }


    }, {
      threshold: threshold
    });

    

    $("*[watch-visibility]").each(function(index, element) {
      window.obz.observe(element);
    })

  }
}
